import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { DashboardComponent } from './dashboard/dashboard.component';
import { AuthGuard } from 'src/app/auth/auth.guard';
import { RoleGuardGuard } from 'src/app/auth/role-guard.guard';
import { ProfileViewComponent } from './profile-view/profile-view.component';
import { EmployeeDetailsComponent } from '../employee-details/employee-details.component';

const routes: Routes = [

  {
    path: '',
    component: DashboardComponent,
    canActivate: [AuthGuard, RoleGuardGuard],
    data: {
      breadcrumb: 'Home/Dashboard',
      roles: ['SuperAdmin', 'Admin', 'Leadership', 'Skill.User', 'CompetencyLeader', 'SubCompetencyLeader'],
    }
  },
  
  {
    path: 'Profile_view/Employee_details',
    component: EmployeeDetailsComponent,
    canActivate: [AuthGuard, RoleGuardGuard],
    data: {
      roles: ['SuperAdmin', 'Admin', 'Leadership', 'CompetencyLeader', 'SubCompetencyLeader', 'Skill.User'],
      preload: true,
      breadcrumb: 'Home/Dashboard/Profile View/Employee Details'
    }

  },

  {
    path: 'Profile View',
    component: ProfileViewComponent,
    canActivate: [AuthGuard, RoleGuardGuard],
    data: {
      roles: ['SuperAdmin', 'Admin', 'Leadership', 'CompetencyLeader', 'SubCompetencyLeader', 'Skill.User'],
      preload: true,
      breadcrumb: 'Home/Dashboard/Profile View'
    }

  },
  {
    path: 'Home/Dashboard/Profile View',
    component: ProfileViewComponent,
    canActivate: [AuthGuard, RoleGuardGuard],
    data: {
      roles: ['SuperAdmin', 'Leadership', 'CompetencyLeader', 'SubCompetencyLeader', 'Skill.User'],
      preload: true,
    }

  },
  {
    path: 'Employee-details/:EmployeeId',
    component: EmployeeDetailsComponent,
    canActivate: [AuthGuard, RoleGuardGuard],
    data: {
      roles: ['SuperAdmin', 'Admin', 'Leadership', 'CompetencyLeader', 'SubCompetencyLeader', 'Skill.User'],
      preload: true,
      breadcrumb: 'Home/Dashboard/Employee Details'
    }
  },


];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class DashboardRoutingModule { }
